import { Activityeditor, Allotment } from '@linktivity/gds-neo';
export const JobState = Allotment.JobState;
export type JobState = Allotment.JobState;
export const TaskStatus = Activityeditor.TaskStatus;
export type TaskStatus = Activityeditor.TaskStatus;
export const ActivityCategory = Activityeditor.ActivityCategory;
export type ActivityCategory = Activityeditor.ActivityCategory;

export const VoucherType = Activityeditor.VoucherType;
export type VoucherType = Activityeditor.VoucherType;
export const QRCodeDisplayLocation = Activityeditor.QRCodeDisplayLocation;
export type QRCodeDisplayLocation = Activityeditor.QRCodeDisplayLocation;
export const QRCodeType = Activityeditor.QRCodeType;
export type QRCodeType = Activityeditor.QRCodeType;

export const VoucherMedium = Activityeditor.VoucherMedium;
export type VoucherMedium = Activityeditor.VoucherMedium;
export const VoucherVersion = Activityeditor.VoucherVersion;
export type VoucherVersion = Activityeditor.VoucherVersion;
export const CancellationSpecApplyTiming =
  Activityeditor.CancellationSpecApplyTiming;
export type CancellationSpecApplyTiming =
  Activityeditor.CancellationSpecApplyTiming;
export const FixedFeeCollectingType = Activityeditor.FixedFeeCollectingType;
export type FixedFeeCollectingType = Activityeditor.FixedFeeCollectingType;
export const BasePrice = Activityeditor.Base;
export type BasePrice = Activityeditor.Base;
export const ConfirmationType = Activityeditor.ConfirmationType;
export type ConfirmationType = Activityeditor.ConfirmationType;
export const DatePeriodUnit = Activityeditor.DatePeriodUnit;
export type DatePeriodUnit = Activityeditor.DatePeriodUnit;
export const ChecklistType = Activityeditor.ChecklistType;
export type ChecklistType = Activityeditor.ChecklistType;
export const VISIBILITY_SETTING_TYPES = [
  'hideFromVoucher',
  'hideFromActivityDetails',
  'hideFromBookingDetails'
] as const;
export type VISIBILITY_SETTING_TYPES =
  (typeof VISIBILITY_SETTING_TYPES)[number];

export const AdditionalFormCollectingType =
  Activityeditor.AdditionalFormCollectingType;
export type AdditionalFormCollectingType =
  Activityeditor.AdditionalFormCollectingType;
export const CollectingTiming = Activityeditor.CollectingTiming;
export type CollectingTiming = Activityeditor.CollectingTiming;

export const FormType = Activityeditor.FormType;
export type FormType = Activityeditor.FormType;
export const UnitType = Activityeditor.UnitType;
export type UnitType = Activityeditor.UnitType;
export const DayOfWeek = Activityeditor.DayOfWeek;
export type DayOfWeek = Activityeditor.DayOfWeek;

export const Operation = Activityeditor.CommonOperation;
export type Operation = Activityeditor.CommonOperation;

export const LOG_TYPE = {
  ACTIVITY: 'ACTIVITY',
  PRICE: 'PRICE',
  PLAN: 'PLAN'
};

export const PaymentCollector = Activityeditor.PaymentCollector;
export const TemplateSource = Activityeditor.TemplateSource;
